<template>
  <div class="fade-wrapper" v-if="loader">
    <span class="loader"></span>
  </div>
</template>

<script>

export default {
  name: "Loader",
  props: ['loader'],
}
</script>

<style scoped>

</style>
